import { render, staticRenderFns } from "./toaplay.vue?vue&type=template&id=6b1aceb9&scoped=true"
import script from "./toaplay.vue?vue&type=script&lang=js"
export * from "./toaplay.vue?vue&type=script&lang=js"
import style0 from "./toaplay.vue?vue&type=style&index=0&id=6b1aceb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1aceb9",
  null
  
)

export default component.exports